<template>
  <div>
    <div id="relen">
      <div style="display:flex;">
        <el-autocomplete
          class="inline-input"
          v-model="state2"
          :fetch-suggestions="querySearch"
          placeholder="请输入商品名称"
          :trigger-on-focus="false"
          @input="handleFocus"
          @select="handleSelect"
        >
          <template slot-scope="{ item }">
            <span class="addr">{{ item.name }}</span>
          </template>
        </el-autocomplete>
        <el-select v-model="paras.status" placeholder="请选择" @change="handleSearch">
          <el-option v-for="n in travelStatus" :key="n.key" :label="n.label" :value="n.value"></el-option>
        </el-select>
      </div>
      <div class="comond_btn">
        <el-button @click="handleEdit()">添加商品</el-button>
      </div>
      <template>
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="商品图片" prop="pic">
            <template slot-scope="scope">
              <img style="width:50px;height:50px;border:none;" :src="scope.row.pic" />
            </template>
          </el-table-column>
          <el-table-column label="商品名称" prop="name"></el-table-column>
          <el-table-column label="品牌" prop="brandName"></el-table-column>
          <el-table-column label="商品价格" prop="price"></el-table-column>
          <el-table-column label="会员价格" prop="promotionPrice"></el-table-column>
          <el-table-column label="库存" prop="stock"></el-table-column>
          <el-table-column label="销量" prop="sale"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)"
              >{{publishStatus===1?'下架':'上架'}}</el-button>
              <!-- <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
              <el-button
                size="mini"
                type="primary"
                @click="handleEditProduct(scope.$index, scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </template>
    </div>
    <div>
      <el-dialog
        title="编辑商品"
        :visible.sync="editProductDiolog"
        width="60%"
        :show-close="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="基础信息" name="first">
            <el-form :model="form" ref="form">
              <el-form-item label="店铺" :label-width="formLabelWidth" prop="brandList">
                <el-select v-model="form.brandList" placeholder="请选择店铺">
                  <el-option
                    v-for="item in brandList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="一级分类" :label-width="formLabelWidth" prop="typeOneId">
                <el-select v-model="form.typeOneId" placeholder="请选择一级分类" @change="getTypeTwoData">
                  <el-option
                    v-for="item in parentlist"
                    :key="item.key"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="二级分类" :label-width="formLabelWidth" prop="typeList">
                <el-select v-model="form.typeList" placeholder="请选择二级分类">
                  <el-option
                    v-for="item in childlist"
                    :key="item.key"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品名" :label-width="formLabelWidth" prop="name">
                <el-input v-model="form.name" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="新品状态" :label-width="formLabelWidth" prop="newStatus">
                <el-select v-model="form.newStatus" placeholder="请选择新品状态">
                  <el-option
                    v-for="item in getNewStatusList"
                    :key="item.key"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="推荐状态(是否要放在首页展示)"
                :label-width="formLabelWidth"
                prop="recommandStatus"
              >
                <el-select v-model="form.recommandStatus" placeholder="请选择推荐状态">
                  <el-option
                    v-for="item in getRecommandStatusList"
                    :key="item.key"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="赠送的成长值" :label-width="formLabelWidth" prop="giftGrowth">
                <el-input v-model="form.giftGrowth" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="赠送的积分" :label-width="formLabelWidth" prop="giftPoint">
                <el-input v-model="form.giftPoint" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="积分限制" :label-width="formLabelWidth" prop="usePointLimit">
                <el-input v-model="form.usePointLimit" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="库存预警值" :label-width="formLabelWidth" prop="lowStock">
                <el-input v-model="form.lowStock" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="单位" :label-width="formLabelWidth" prop="unit">
                <el-input v-model="form.unit" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="商品重量(克)" :label-width="formLabelWidth" prop="weight">
                <el-input v-model="form.weight" autocomplete="off"></el-input>
              </el-form-item>
              <el-form-item label="邮费" :label-width="formLabelWidth" prop="transfee">
                <el-input v-model="form.transfee" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div style=" display: flex;justify-content: flex-end;">
              <el-button @click="handleEditCancleProduct()">取 消</el-button>
              <el-button type="primary" @click="saveOne()">保 存</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="图片" name="second">
            <div>
              <el-form>
                <!-- 拖拽 -->
                <el-form-item label="产品主图(750*750):" :label-width="formLabelWidth">
                  <ul class="el-upload-list el-upload-list--picture-card">
                    <div>
                      <draggable
                        class="el-upload-list el-upload-list--picture-card"
                        v-model="mainPicListTwo"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        @update="updateList2"
                      >
                        <div
                          class="el-upload-list__item is-success"
                          v-for="(item, index) in mainPicListTwo"
                          :key="item + index"
                        >
                          <li>
                            <div class="content1">
                              <img :src="item.url" class="el-upload-list__item is-success" />
                              <span class="el-upload-list__item-actions">
                                <span class="remove">
                                  <i class="el-icon-remove" @click="delImg3(index)"></i>
                                </span>
                              </span>
                            </div>
                          </li>
                        </div>
                      </draggable>
                    </div>
                    <li>
                      <el-upload
                        action="https://upload-z0.qiniup.com"
                        list-type="picture-card"
                        :before-upload="(file) => { return handleBeforeUpload(file, 'editProductpic') }"
                        :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'editProductpic') }"
                        :data="qiniu"
                        :show-file-list="false"
                        :file-list="mainPicListTwo"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </li>
                  </ul>
                </el-form-item>

                <!-- 拖拽 -->
                <el-form-item label="产品从图(750*750):" :label-width="formLabelWidth">
                  <ul class="el-upload-list el-upload-list--picture-card">
                    <div>
                      <draggable
                        class="el-upload-list el-upload-list--picture-card"
                        v-model="congPicListTwo"
                        @start="isDragging = true"
                        @end="isDragging = false"
                        @update="updateList3"
                      >
                        <div
                          class="el-upload-list__item is-success"
                          v-for="(item, index) in congPicListTwo"
                          :key="item + index"
                        >
                          <li>
                            <div class="content1">
                              <img :src="item.url" class="el-upload-list__item is-success" />
                              <span class="el-upload-list__item-actions">
                                <span class="remove">
                                  <i class="el-icon-remove" @click="delImg4(index)"></i>
                                </span>
                              </span>
                            </div>
                          </li>
                        </div>
                      </draggable>
                    </div>
                    <li>
                      <el-upload
                        action="https://upload-z0.qiniup.com"
                        list-type="picture-card"
                        :before-upload="(file) => { return handleBeforeUpload(file, 'editProductpicCong') }"
                        :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'editProductpicCong') }"
                        :data="qiniu"
                        :show-file-list="false"
                        :file-list="congPicListTwo"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </li>
                  </ul>
                </el-form-item>
              </el-form>
            </div>
            <div style=" display: flex;justify-content: flex-end;">
              <el-button @click="handleEditCancleProduct()">取 消</el-button>
              <el-button type="primary" @click="saveTwo()">保 存</el-button>
            </div>
          </el-tab-pane>
          <el-tab-pane label="规格" name="third">
            <div>
              <el-form ref="form" v-model="form">
                <P v-for="(n) in form.attributeList" :key="n.key" style="margin-top:10px">
                  <el-form-item label="一级规格" :label-width="formLabelWidth">
                    <el-input v-model="n.name" placeholder="请输入规格名称"></el-input>
                  </el-form-item>
                  <div style="display: flex;justify-content: flex-end;">
                    <el-button @click.prevent="removeEditDom(n)" type="danger">删除</el-button>
                  </div>
                </P>
                <el-button @click="addDom()">新增规格参数</el-button>
              </el-form>
              <div style=" display: flex;justify-content: flex-end;">
                <el-button @click="handleEditCancleProduct()">取 消</el-button>
                <el-button type="primary" @click="saveThree()">保 存</el-button>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="销售参数" name="fourth">
            <div>
              <el-form v-model="form" ref="form">
                <p v-for="(n,index) in form.addSaleList" :key="n.id">
                  <el-form-item label="规格" :label-width="formLabelWidth">
                    <span>{{n.name}}</span>
                  </el-form-item>
                  <el-form-item label="规格对应图片" :label-width="formLabelWidth">
                    <el-upload
                      class="avatar-uploader2"
                      :data="qiniu"
                      action="https://upload-z0.qiniup.com"
                      :show-file-list="false"
                      :before-upload="(file) => { return handleBeforeUpload(file, 'guigeEdit') }"
                      :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'guigeEdit',index) }"
                    >
                      <img
                        v-if="form.addSaleList[index].imgUrl"
                        :src="form.addSaleList[index].imgUrl"
                        class="avatar2"
                      />
                      <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
                    </el-upload>
                  </el-form-item>
                  <el-form-item label="二级规格" :label-width="formLabelWidth">
                    <el-input v-model="n.inputListName" placeholder="请输入二级规格"></el-input>
                  </el-form-item>
                  <el-form-item label="价格" :label-width="formLabelWidth">
                    <el-input v-model="n.salesPrice" placeholder="请输入当前规格价格"></el-input>
                  </el-form-item>
                  <el-form-item label="会员价" :label-width="formLabelWidth">
                    <el-input v-model="n.promotionPrice" placeholder="请输入当前规格会员价"></el-input>
                  </el-form-item>
                  <el-form-item label="库存" :label-width="formLabelWidth">
                    <el-input v-model="n.stock" placeholder="请输入当前规格库存"></el-input>
                  </el-form-item>
                </p>
              </el-form>
              <div style=" display: flex;justify-content: flex-end;">
                <el-button @click="handleEditCancleProduct()">取 消</el-button>
                <el-button type="primary" @click="saveFour()">保 存</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-dialog>
    </div>

    <!-- 添加商品dialog -->
    <div>
      <el-dialog
        :title="diologTitle"
        :visible.sync="dialogVisible"
        width="50%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form :model="form" ref="form">
          <el-form-item label="店铺" :label-width="formLabelWidth" prop="brandList">
            <el-select v-model="form.brandList" placeholder="请选择店铺">
              <el-option
                v-for="item in brandList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="一级分类" :label-width="formLabelWidth" prop="typeOneId">
            <el-select v-model="form.typeOneId" placeholder="请选择一级分类" @change="getTypeTwoData">
              <el-option
                v-for="item in parentlist"
                :key="item.key"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="二级分类" :label-width="formLabelWidth" prop="typeList">
            <el-select v-model="form.typeList" placeholder="请选择二级分类">
              <el-option
                v-for="item in childlist"
                :key="item.key"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品名" :label-width="formLabelWidth" prop="name">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="新品状态" :label-width="formLabelWidth" prop="newStatus">
            <el-select v-model="form.newStatus" placeholder="请选择新品状态">
              <el-option
                v-for="item in getNewStatusList"
                :key="item.key"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="推荐状态(是否要放在首页展示)"
            :label-width="formLabelWidth"
            prop="recommandStatus"
          >
            <el-select v-model="form.recommandStatus" placeholder="请选择推荐状态">
              <el-option
                v-for="item in getRecommandStatusList"
                :key="item.key"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="赠送的成长值" :label-width="formLabelWidth" prop="giftGrowth">
            <el-input v-model="form.giftGrowth" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="赠送的积分" :label-width="formLabelWidth" prop="giftPoint">
            <el-input v-model="form.giftPoint" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="积分限制" :label-width="formLabelWidth" prop="usePointLimit">
            <el-input v-model="form.usePointLimit" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="库存预警值" :label-width="formLabelWidth" prop="lowStock">
            <el-input v-model="form.lowStock" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="单位" :label-width="formLabelWidth" prop="unit">
            <el-input v-model="form.unit" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="商品重量(克)" :label-width="formLabelWidth" prop="weight">
            <el-input v-model="form.weight" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮费" :label-width="formLabelWidth" prop="transfee">
            <el-input v-model="form.transfee" autocomplete="off"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleCancle()">取 消</el-button>
          <el-button type="primary" @click="handleSave()">下一步</el-button>
        </span>
      </el-dialog>
    </div>

    <!-- 商品上传第二步 -->
    <div>
      <el-dialog
        title="添加商品图片"
        :visible.sync="productPicdialog"
        width="50%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form>
          <!-- 拖拽 -->
          <el-form-item label="产品主图(750*750):" :label-width="formLabelWidth">
            <ul class="el-upload-list el-upload-list--picture-card">
              <div>
                <draggable
                  class="el-upload-list el-upload-list--picture-card"
                  v-model="mainPicList"
                  @start="isDragging = true"
                  @end="isDragging = false"
                  @update="updateList"
                >
                  <div
                    class="el-upload-list__item is-success"
                    v-for="(item, index) in mainPicList"
                    :key="item + index"
                  >
                    <li>
                      <div class="content1">
                        <img :src="item.url" class="el-upload-list__item is-success" />
                        <span class="el-upload-list__item-actions">
                          <span class="remove">
                            <i class="el-icon-remove" @click="delImg(index)"></i>
                          </span>
                        </span>
                      </div>
                    </li>
                  </div>
                </draggable>
              </div>
              <li>
                <el-upload
                  action="https://upload-z0.qiniup.com"
                  list-type="picture-card"
                  :before-upload="(file) => { return handleBeforeUpload(file, 'productpic') }"
                  :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'productpic') }"
                  :data="qiniu"
                  multiple
                  :show-file-list="false"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </li>
            </ul>
          </el-form-item>

          <!-- 拖拽 -->
          <el-form-item label="产品从图(750*750):" :label-width="formLabelWidth">
            <ul class="el-upload-list el-upload-list--picture-card">
              <div>
                <draggable
                  class="el-upload-list el-upload-list--picture-card"
                  v-model="congPicList"
                  @start="isDragging = true"
                  @end="isDragging = false"
                  @update="updateList"
                >
                  <div
                    class="el-upload-list__item is-success"
                    v-for="(item, index) in congPicList"
                    :key="item + index"
                  >
                    <li>
                      <div class="content1">
                        <img :src="item.url" class="el-upload-list__item is-success" />
                        <span class="el-upload-list__item-actions">
                          <span class="remove">
                            <i class="el-icon-remove" @click="delImg2(index)"></i>
                          </span>
                        </span>
                      </div>
                    </li>
                  </div>
                </draggable>
              </div>
              <li>
                <el-upload
                  action="https://upload-z0.qiniup.com"
                  list-type="picture-card"
                  :before-upload="(file) => { return handleBeforeUpload(file, 'productpicCong') }"
                  :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'productpicCong') }"
                  :data="qiniu"
                  :show-file-list="false"
                  multiple
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </li>
            </ul>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="productPicdialog = false">取 消</el-button>
          <el-button type="primary" @click="handlePicSave()">下一步</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 商品上传第三步  规格参数 -->
    <div>
      <el-dialog
        title="添加商品规格"
        :visible.sync="productAttributedialog"
        width="50%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form ref="form" v-model="form">
          <P v-for="(n) in form.attributeList" :key="n.key" style="margin-top:10px">
            <el-form-item label="一级规格" :label-width="formLabelWidth">
              <el-input v-model="n.name" placeholder="请输入规格名称"></el-input>
            </el-form-item>
            <!-- <el-form-item label="规格值" :label-width="formLabelWidth">
              <el-input v-model="n.value" placeholder="请输入规格值"></el-input>
            </el-form-item>-->
            <div style="display: flex;justify-content: flex-end;">
              <el-button @click.prevent="removeDom(n)" type="danger">删除</el-button>
            </div>
          </P>
          <el-button @click="addDom()">新增规格参数</el-button>
        </el-form>

        <span slot="footer" class="dialog-footer">
          <el-button @click="productAttributedialog = false">取 消</el-button>
          <el-button type="primary" @click="handleGuigeSave()">下一步</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 商品上传第四步 销售参数 -->
    <div>
      <el-dialog
        title="添加商品销售参数"
        :visible.sync="productSaledialog"
        width="50%"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <el-form v-model="form">
          <!-- addSaleList 决定了有个sale 模块 包括 规格的name属性值 -->
          <p v-for="(n,index) in form.addSaleList" :key="n.id">
            <el-form-item label="规格" :label-width="formLabelWidth">
              <span>{{n.name}}</span>
            </el-form-item>
            <el-form-item label="规格对应图片" :label-width="formLabelWidth">
              <el-upload
                class="avatar-uploader2"
                :data="qiniu"
                action="https://upload-z0.qiniup.com"
                :show-file-list="false"
                :before-upload="(file) => { return handleBeforeUpload(file, 'guige') }"
                :on-success="(response, file, fileList) => { return handleOnSuccess(response, file, fileList, 'guige') }"
              >
                <img v-if="guigeimgUrl[index]" :src="guigeimgUrl[index]" class="avatar2" />
                <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
              </el-upload>
            </el-form-item>
            <el-form-item label="二级规格" :label-width="formLabelWidth">
              <el-input v-model="n.inputListName" placeholder="请输入二级规格"></el-input>
            </el-form-item>
            <el-form-item label="价格" :label-width="formLabelWidth">
              <el-input v-model="n.salesPrice" placeholder="请输入当前规格价格"></el-input>
            </el-form-item>
            <el-form-item label="会员价" :label-width="formLabelWidth">
              <el-input v-model="n.promotionPrice" placeholder="请输入当前规格会员价"></el-input>
            </el-form-item>
            <el-form-item label="库存" :label-width="formLabelWidth">
              <el-input v-model="n.stock" placeholder="请输入当前规格库存"></el-input>
            </el-form-item>
          </p>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="productSaledialog = false">取 消</el-button>
          <el-button type="primary" @click="handleSaleSave()">上传商品</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="margin-top:30px ;text-align:center; ">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="handelCurrentChange"
        :current-page="currentpageIndex"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import draggable from 'vuedraggable'; // 拖动插件
import { goodsTypegetByParentId, queryBrandList, addProductDto, qiniuupload, addProductPic, addValues, addSalesProduct, queryList, upDateProduct, queryById, quyeryProductPic, updateProductPic, queryValues, addUpValues, querySalesProduct, addUpSalesProduct, addUpSalesProductList, updateProductPics } from '../../api'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    draggable
  },
  data () {
    return {
      editProductDiolog: false,
      activeName: 'first',
      guigeimgUrl: [],
      guigeiEditmgUrl: [],
      //模糊查询
      state2: '',
      restaurants: [],
      travelStatus: [ // 状态列表
        {
          value: 1,
          label: '已上架'
        },
        {
          value: 0,
          label: '已下架'
        }
      ],
      paras: {
        status: 1,
      },
      total: 0,
      publishStatus: 1, //1上架0 下架
      currentpageIndex: 1,
      currentpageSize: 10,
      //图片上传的数组
      productPics: [],
      mainPicList: [],
      congPicList: [],
      mainPicListTwo: [],
      congPicListTwo: [],
      productEditSaledialog: false,
      disabled: false,
      uploadUrl: '', //  七牛上传地址前缀
      qiniu: { //  qiniu
        token: '',
        key: ''
      },
      // 上传的产品id
      productId: '',
      // 分类list
      parentlist: [], //一级
      childlist: [], //二级
      diologTitle: '',
      // 品牌
      brandList: [],
      formLabelWidth: '220px',
      productIdToAddOrEdit: '',
      form: {
        addSaleList: [],
        // 规格参数
        attributeList: [
          {
            name: '',
          }
        ],
        brandList: [],
        typeList: [],
        name: '',
        productSn: '',
        newStatus: '',
        recommandStatus: '',
        giftGrowth: '0',
        giftPoint: '0',
        usePointLimit: '0',
        lowStock: '0',
        unit: '克',
        weight: '0',
        promotionPerLimit: '',
        promotionType: '',
        transfee: '0',
        activityData: '',
      },
      // 商品基础信息
      dialogVisible: false,
      // 商品图片
      productPicdialog: false,
      // 规格参数
      productAttributedialog: false,
      // 销售参数
      productSaledialog: false,
      // 编辑商品部分
      editdialogVisible: false,
      // 列表数据
      tableData: [],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  methods: {
    handleEditCancleProduct () {
      this.editProductDiolog = false
      this.activeName = 'first'
      this.productIdToAddOrEdit = ''
      this.mainPicListTwo = []
      this.congPicListTwo = []
      this.form = {
        addSaleList: [],
        // 规格参数
        attributeList: [
          {
            name: '',
          }
        ],
        brandList: [],
        typeList: [],
        name: '',
        productSn: '',
        newStatus: '',
        recommandStatus: '',
        giftGrowth: '0',
        giftPoint: '0',
        usePointLimit: '0',
        lowStock: '0',
        unit: '克',
        weight: '0',
        promotionPerLimit: '',
        promotionType: '',
        transfee: '0',
        activityData: '',
      }
    },
    // 编辑选项卡
    handleClick (tab, event) {
      console.log("选项", tab.index, event);
    },
    handleEditProduct (index, item) {
      console.log(item);
      this.editProductDiolog = true
      // 表示走的是编辑
      // console.log('编辑', item);
      //通过二级分类查询一级分类
      let para = new URLSearchParams()
      para.append('id', item.productCategoryId)
      queryById(para).then(data => {
        // console.log('一级得到的id', data);
        if (data.code === 10000) {
          this.form.typeOneId = data.data.parentId
          //还要在查询一边二级分类 将数据给到options
          let para = new URLSearchParams()
          para.append('parentId', this.form.typeOneId)
          para.append('pageIndex', 1)
          para.append('pageSize', 100)
          goodsTypegetByParentId(para).then(data => {
            // console.log('二级分类id', data);
            this.childlist = data.data.rows
            //商品id
            this.productIdToAddOrEdit = item.id
            //编辑回显数据
            this.form.brandList = item.brandId
            this.form.typeList = item.productCategoryId
            this.form.name = item.name
            this.form.newStatus = item.newStatus
            this.form.recommandStatus = item.recommandStatus
            this.form.giftGrowth = item.giftGrowth
            this.form.giftPoint = item.giftPoint
            this.form.usePointLimit = item.usePointLimit
            this.form.lowStock = item.lowStock
            this.form.unit = item.unit
            this.form.weight = item.weight
            this.form.transfee = item.transfee
            //请求获取图片数据
            let para = new URLSearchParams();
            para.append("productId", this.productIdToAddOrEdit)
            quyeryProductPic(para).then(data => {
              console.log(data);
              var list = data.data
              for (let i = 0; i < list.length; i++) {
                if (list[i].typeId == 10) {
                  this.mainPicListTwo.push(list[i])
                } else {
                  this.congPicListTwo.push(list[i])
                }
              }
              console.log(this.mainPicListTwo);
              console.log(this.congPicListTwo);

              let para = new URLSearchParams()
              para.append('productId', this.productIdToAddOrEdit)
              queryValues(para).then(data => {
                console.log("最新的规格", data);
                if (data.code === 10000) {
                  this.form.attributeList = data.data
                  //请求销售数据赋值addSaleList
                  let para = new URLSearchParams()
                  para.append('productId', this.productIdToAddOrEdit)
                  querySalesProduct(para).then(data => {
                    console.log(data)
                    //查询出来的原有的销售数据
                    var attdata = this.form.attributeList
                    var saleData = data.data
                    var length = attdata.length - saleData.length
                    console.log(length);
                    if (length > 0) {
                      for (let i = 0; i < length; i++) {
                        let obj = {
                          "inputListName": '',
                          "isValid": 'T',
                          "productId": this.productIdToAddOrEdit,
                          "promotionPrice": '',
                          "salesPrice": '',
                          "stock": '',
                          "imgUrl": ''
                        }
                        saleData.push(obj)
                      }
                    }

                    for (let i = 0; i < attdata.length; i++) {
                      saleData[i]['name'] = attdata[i].name
                      saleData[i]['productAttributeId'] = attdata[i].id
                    }
                    this.form.addSaleList = saleData
                  })
                } else {
                  this.$message({
                    message: data.msg,
                    type: 'error'
                  })
                }
              })
            })

          })
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    delImg (index) {
      this.mainPicList.splice(index, 1)
    },
    delImg2 (index) {
      this.congPicList.splice(index, 1)
    },
    delImg3 (index) {
      let para = new URLSearchParams()
      para.append('id', this.mainPicListTwo[index].id)
      para.append('productId', this.mainPicListTwo[index].productId)
      para.append('typeId', this.mainPicListTwo[index].typeId)
      para.append('url', this.mainPicListTwo[index].url)
      para.append('isValid', 'F')
      updateProductPic(para).then(data => {
        console.log(data);
        this.mainPicListTwo.splice(index, 1)
      })

    },
    delImg4 (index) {
      let para = new URLSearchParams()
      para.append('id', this.congPicListTwo[index].id)
      para.append('productId', this.congPicListTwo[index].productId)
      para.append('typeId', this.congPicListTwo[index].typeId)
      para.append('url', this.congPicListTwo[index].url)
      para.append('isValid', 'F')
      updateProductPic(para).then(data => {
        console.log(data);
        this.congPicListTwo.splice(index, 1)
      })
    },
    // 更新之后
    updateList (e) {
      const newIndex = e.newIndex// 新位置下标
      const oldIndex = e.oldIndex// 原始位置下标
      // 打印出新位置 位置从0开始算
      console.log(newIndex)
      console.log(oldIndex)
      // 打印出来的为该位置的对象
      // console.log(this.mainPicList)
    },
    // 编辑主图调换顺序
    updateList2 (e) {
      console.log('最新的', this.mainPicListTwo);
      const newIndex = e.newIndex// 新位置下标
      const oldIndex = e.oldIndex// 原始位置下标
      // 打印出新位置 位置从0开始算
      console.log(newIndex)
      console.log(oldIndex)

      for (let i = 0; i < this.mainPicListTwo.length; i++) {
        this.mainPicListTwo[i].idx = i
      }

    },
    // 编辑从图调换顺序
    updateList3 (e) {
      const newIndex = e.newIndex// 新位置下标
      const oldIndex = e.oldIndex// 原始位置下标
      // 打印出新位置 位置从0开始算
      console.log(newIndex)
      console.log(oldIndex)
      for (let i = 0; i < this.congPicListTwo.length; i++) {
        this.congPicListTwo[i].idx = i
      }
    },
    handleFocus (item) {
      console.log('输入', item);
      if (item === '') {
        console.log(1111);
        this.getShopList()
      }
    },
    handleSelect (item) {
      // console.log(item);
      this.state2 = item.name
      var arr = []
      arr.push(item)
      this.tableData = arr

    },
    querySearch (queryString, cb) {
      let para = new URLSearchParams()
      para.append('name', queryString)

      queryList(para).then(data => {
        console.log('查出来的：', data);
        this.restaurants = data.data.rows

        var restaurants = this.restaurants;
        console.log('全部数据', restaurants);

        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        console.log('过滤数据1', this.createFilter(queryString));
        console.log('过滤数据2', restaurants.filter(this.createFilter(queryString)));
        console.log('组件返回数据', results);

        // 调用 callback 返回建议列表的数据
        cb(results);
      })
    },
    createFilter (queryString) {
      return (restaurant) => {
        console.log('当前数据', restaurant);
        return (restaurant.name.toLowerCase().includes(queryString.toLowerCase()));

      };
    },

    handleCancle () {
      this.dialogVisible = false
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    handleEdit () {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
      console.log('新增', 2222);
      this.productIdToAddOrEdit = ''
      this.diologTitle = '新增商品基础信息'
    },
    //下架、上架
    handleDelete (index, item) {
      if (this.publishStatus === 1) {
        console.log(index, item);
        let para = new URLSearchParams()
        para.append('productId', item.id)
        para.append('publishStatus', 0)
        para.append('verifyStatus', 1)
        upDateProduct(para).then(data => {
          // console.log(data);
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getShopList()
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      } else {
        console.log(index, item);
        let para = new URLSearchParams()
        para.append('productId', item.id)
        para.append('publishStatus', 1)
        para.append('verifyStatus', 1)
        upDateProduct(para).then(data => {
          if (data.code === 10000) {
            this.$message({
              message: data.msg,
              type: 'success'
            })
            this.getShopList()
          } else {
            this.$message({
              message: data.msg,
              type: 'error'
            })
          }
        })
      }

    },
    //筛选
    handleSearch (index) {
      console.log(index);
      this.publishStatus = index
      this.currentpageIndex = 1
      this.getShopList()
    },
    //获取商品列表
    getShopList () {
      let para = new URLSearchParams()
      para.append('deleteStatus', 0)
      para.append('pageIndex', this.currentpageIndex)
      para.append('pageSize', this.currentpageSize)
      para.append('publishStatus', this.publishStatus)
      para.append('verifyStatus', 1)
      queryList(para).then(data => {
        console.log('列表数据', data);
        if (data.code === 10000) {
          this.tableData = data.data.rows
          this.total = data.data.total
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    handelCurrentChange (i) { // 分页
      // console.log(i);
      this.currentpageIndex = i
      this.getShopList()
    },

    handleSaleSave () {
      console.log("最新的数据", this.form.addSaleList);
      console.log(this.guigeimgUrl);
      for (let i = 0; i < this.form.addSaleList.length; i++) {
        this.form.addSaleList[i].productAttributeId = this.form.addSaleList[i].id
        this.form.addSaleList[i].imgUrl = this.guigeimgUrl[i]
      }
      addSalesProduct(JSON.stringify(this.form.addSaleList)).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.guigeimgUrl = []
          this.$message({
            message: data.msg,
            type: 'success'
          })
          //关闭窗口
          this.productSaledialog = false
          //查询一遍列表
          this.getShopList()
        }
      })

    },
    //第3部分规格参数提交
    handleGuigeSave () {
      // console.log("规格参数数据：", this.form.attributeList);
      for (let i = 0; i < this.form.attributeList.length; i++) {
        this.form.attributeList[i].productId = this.productId
      }
      addValues(JSON.stringify(this.form.attributeList)).then(data => {
        console.log('第三部：', data);
        //拿到返回的对象 保存  2 关闭当前的窗口  3 打开新的窗口
        // 1保存对象
        this.form.addSaleList = data.data
        this.form.addSaleList.inputListName = ''
        this.form.addSaleList.salesPrice = ''
        this.form.addSaleList.promotionPrice = ''
        this.form.addSaleList.stock = ''
        // 2 关闭窗口
        this.productAttributedialog = false
        // 3  打开新的窗口
        this.productSaledialog = true
        let arr = this.form.attributeList
        for (let i = 0; i < arr.length; i++) {
          arr[i].name = ''
        }
      })

    },
    //第3部规格的增加
    addDom () { //  增加参数
      //新增
      this.form.attributeList.push({
        name: '',
        // value: ''
      })
    },
    removeEditDom (item) {
      console.log('删除规格前：', item);
      let dom = this.form.attributeList
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        if (item.id) {
          item.isValid = 'F'
          addUpValues(JSON.stringify(item)).then(data => {
            console.log('编辑原来的数据：', data);
            //先删除掉原先的对应的销售数据
            let para = new URLSearchParams()
            para.append('productId', this.productIdToAddOrEdit)
            querySalesProduct(para).then(data => {
              console.log('删除规格之后查询销售数据', data);
              var saleList = data.data
              for (let i = 0; i < saleList.length; i++) {
                if (saleList[i].productAttributeId == item.id) {
                  let para = new URLSearchParams()
                  para.append('id', saleList[i].id)
                  para.append('productId', saleList[i].productId)
                  para.append('productAttributeId', saleList[i].productAttributeId)
                  para.append('inputListName', saleList[i].inputListName)
                  para.append('salesPrice', saleList[i].salesPrice)
                  para.append('promotionPrice', saleList[i].promotionPrice)
                  para.append('stock', '0')
                  para.append('isValid', 'F')
                  addUpSalesProduct(para).then(data => {
                    console.log(data);
                  })
                }
              }
            })
            let para1 = new URLSearchParams()
            para1.append('productId', this.productIdToAddOrEdit)
            queryValues(para1).then(data => {
              console.log('删除之后查询：', data);
              this.form.attributeList = data.data
            })
          })
        }
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }

    },
    removeDom (item) { //  删除元素
      let dom = this.form.attributeList
      if (dom.length <= 1) {
        this.$message.error('至少一个参数')
      } else {
        var index = dom.indexOf(item)
        if (index !== -1) {
          dom.splice(index, 1)
        }
      }
    },
    // 七牛部分
    getToken () {
      let para = new URLSearchParams()
      para.append('bucket', 'productpic')
      qiniuupload(para).then((res) => {
        // console.log(res.data)
        this.qiniu.token = res.data.token;
        this.uploadUrl = res.data.bucketUrl
      })
    },

    //七牛
    handleOnSuccess (response, file, fileList, obj, index) { //  上传成功之后
      console.log(response, file, fileList, obj);
      if (obj === 'productpicCong') {
        this.congPicList.push({
          url: this.uploadUrl + "/" + response.key
        })
      } else if (obj === 'productpic') {
        this.mainPicList.push({
          url: this.uploadUrl + "/" + response.key
        });


      } else if (obj === 'guige') {

        this.guigeimgUrl.push(this.uploadUrl + "/" + response.key)

      } else if (obj === 'guigeEdit') {
        console.log(this.form.addSaleList);
        console.log(index);
        this.form.addSaleList[index].imgUrl = this.uploadUrl + "/" + response.key
        console.log(this.form.addSaleList);

      } else if (obj === 'editProductpic') {
        let para = new URLSearchParams()
        para.append('productId', this.productIdToAddOrEdit)
        para.append('typeId', 10)
        para.append('url', this.uploadUrl + "/" + response.key)
        para.append('isValid', 'T')
        para.append('idx', this.mainPicListTwo.length)
        updateProductPic(para).then(data => {
          console.log(data);
          let para = new URLSearchParams();
          para.append("productId", this.productIdToAddOrEdit)
          quyeryProductPic(para).then(data => {
            console.log(data);
            var list = data.data
            this.mainPicListTwo = []
            this.congPicListTwo = []
            for (let i = 0; i < list.length; i++) {
              if (list[i].typeId == 10) {
                this.mainPicListTwo.push(list[i])
              } else {
                this.congPicListTwo.push(list[i])
              }
            }
            console.log(this.mainPicListTwo);
            console.log(this.congPicListTwo);
          })
        })
      } else if (obj === 'editProductpicCong') {

        let para = new URLSearchParams()
        para.append('productId', this.productIdToAddOrEdit)
        para.append('typeId', 20)
        para.append('url', this.uploadUrl + "/" + response.key)
        para.append('isValid', 'T')
        para.append('idx', this.mainPicListTwo.length)
        updateProductPic(para).then(data => {
          console.log(data);
          let para = new URLSearchParams();
          para.append("productId", this.productIdToAddOrEdit)
          quyeryProductPic(para).then(data => {
            console.log(data);
            var list = data.data
            this.mainPicListTwo = []
            this.congPicListTwo = []
            for (let i = 0; i < list.length; i++) {
              if (list[i].typeId == 10) {
                this.mainPicListTwo.push(list[i])
              } else {
                this.congPicListTwo.push(list[i])
              }
            }
            console.log(this.mainPicListTwo);
            console.log(this.congPicListTwo);
          })
        })
      }
    },
    handleBeforeUpload (file, obj) { //  上传之前
      this.qiniu.key = obj + `${moment().format('YYYYMMDDHHmmSSS')}${Number.parseInt(Math.random() * 1000, 10)}.${file.type.split('/')[1]}`
    },
    //选择一级分类通过分类得到二级分类
    getTypeTwoData (e) {
      console.log(e);
      this.childlist = []
      this.form.typeTwoId = ''
      this.getgoodsTypegetByParentId(e)
    },

    getgoodsTypegetByParentId (p) { //  查询全部
      let para = new URLSearchParams()
      if (p) {
        para.append('parentId', p)
        para.append('pageIndex', 1)
        para.append('pageSize', 100)
        goodsTypegetByParentId(para).then(data => {
          console.log('二级分类id', data);
          this.childlist = data.data.rows
        })
      } else {
        para.append('pageIndex', 1)
        para.append('pageSize', 100)
        goodsTypegetByParentId(para).then(data => {
          // console.log(data);
          if (data.code === 10000) {
            this.parentlist = data.data.rows
          } else {
            console.log(data)
          }
        })
      }
    },

    // 查询店铺列表
    queryBrandList () {
      let para = new URLSearchParams()
      para.append('pageIndex', 1)
      para.append('pageSize', 1000)
      //请求接口
      queryBrandList(para).then(data => {
        // console.log('品牌', data);
        if (data.code === 10000) {
          this.brandList = data.data.rows
          // console.log('正常的赋值', this.brandList);
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    saveOne () {
      // 编辑第一步
      let para = new URLSearchParams();
      para.append("id", this.productIdToAddOrEdit);
      para.append("brandId", this.form.brandList);
      para.append("productCategoryId", this.form.typeList);
      para.append("name", this.form.name);
      para.append("newStatus", this.form.newStatus);
      para.append("recommandStatus", this.form.recommandStatus);
      para.append("giftGrowth", this.form.giftGrowth);
      para.append("giftPoint", this.form.giftPoint);
      para.append("usePointLimit", this.form.usePointLimit);
      para.append("lowStock", this.form.lowStock);
      para.append("unit", this.form.unit);
      para.append("weight", this.form.weight);
      para.append("transfee", this.form.transfee);
      addProductDto(para).then(data => {
        console.log('第一步修改信息', data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          // 成功之后再上架
          this.editProductDiolog = false
          this.form = {
            addSaleList: [],
            // 规格参数
            attributeList: [
              {
                name: '',
              }
            ],
            brandList: [],
            typeList: [],
            name: '',
            productSn: '',
            newStatus: '',
            recommandStatus: '',
            giftGrowth: '0',
            giftPoint: '0',
            usePointLimit: '0',
            lowStock: '0',
            unit: '克',
            weight: '0',
            promotionPerLimit: '',
            promotionType: '',
            transfee: '0',
            activityData: '',
          }
          this.mainPicListTwo = []
          this.congPicListTwo = []
          this.activeName = 'first'
          this.addUpdataStatuesShop()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
    },
    saveTwo () {
      // 全量反图片集合
      console.log();

      var editProductPics = []
      for (let i = 0; i < this.mainPicListTwo.length; i++) {
        this.mainPicListTwo[i].idx = i
        editProductPics.push(this.mainPicListTwo[i])
      }
      for (let i = 0; i < this.congPicListTwo.length; i++) {
        this.congPicListTwo[i].idx = i
        editProductPics.push(this.congPicListTwo[i])
      }
      console.log('编辑之后的图片结合', editProductPics);
      updateProductPics(JSON.stringify(editProductPics)).then(data => {
        console.log('编辑图片', data);
        //下一步 关闭当前窗口 然后 打开规格参数窗口
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.editProductDiolog = false
          this.form = {
            addSaleList: [],
            // 规格参数
            attributeList: [
              {
                name: '',
              }
            ],
            brandList: [],
            typeList: [],
            name: '',
            productSn: '',
            newStatus: '',
            recommandStatus: '',
            giftGrowth: '0',
            giftPoint: '0',
            usePointLimit: '0',
            lowStock: '0',
            unit: '克',
            weight: '0',
            promotionPerLimit: '',
            promotionType: '',
            transfee: '0',
            activityData: '',
          }
          this.mainPicListTwo = []
          this.congPicListTwo = []
          this.activeName = 'first'
          // 重新查询一遍列表数据
          this.getShopList()
        }
      })
    },
    saveThree () {
      console.log('编辑第三部', this.form.attributeList);
      for (let i = 0; i < this.form.attributeList.length; i++) {
        this.form.attributeList[i].productId = this.productIdToAddOrEdit
      }
      console.log('编辑规格更改id数据：', this.form.attributeList);
      for (let i = 0; i < this.form.attributeList.length; i++) {
        addUpValues(JSON.stringify(this.form.attributeList[i])).then(data => {
          console.log('编辑原来的数据：', data);
        })
      }
      this.editProductDiolog = false
      this.form = {
        addSaleList: [],
        // 规格参数
        attributeList: [
          {
            name: '',
          }
        ],
        brandList: [],
        typeList: [],
        name: '',
        productSn: '',
        newStatus: '',
        recommandStatus: '',
        giftGrowth: '0',
        giftPoint: '0',
        usePointLimit: '0',
        lowStock: '0',
        unit: '克',
        weight: '0',
        promotionPerLimit: '',
        promotionType: '',
        transfee: '0',
        activityData: '',
      }
      this.mainPicListTwo = []
      this.congPicListTwo = []
      this.activeName = 'first'
      this.$message({
        message: "操作成功",
        type: 'success'
      })
    },
    saveFour () {
      // 接口更改不需要遍历 直接list 数据全部提交
      console.log('提交sale之前的数据', this.form.addSaleList);
      addUpSalesProductList(JSON.stringify(this.form.addSaleList)).then(data => {
        console.log(data);
        if (data.code === 10000) {
          this.guigeimgUrl = []
          this.form = {
            addSaleList: [],
            // 规格参数
            attributeList: [
              {
                name: '',
              }
            ],
            brandList: [],
            typeList: [],
            name: '',
            productSn: '',
            newStatus: '',
            recommandStatus: '',
            giftGrowth: '0',
            giftPoint: '0',
            usePointLimit: '0',
            lowStock: '0',
            unit: '克',
            weight: '0',
            promotionPerLimit: '',
            promotionType: '',
            transfee: '0',
            activityData: '',
          }
          this.mainPicListTwo = []
          this.congPicListTwo = []
          this.activeName = 'first'
          this.$message({
            message: data.msg,
            type: 'success'
          })
          //关闭窗口
          this.editProductDiolog = false
          //查询一遍列表
          this.getShopList()
        }
      })
    },
    //添加商品第一步：基础信息
    handleSave () {
      let para = new URLSearchParams();
      if (this.productIdToAddOrEdit) {
        para.append("id", this.productIdToAddOrEdit);
      }
      para.append("brandId", this.form.brandList);
      // para.append("brandName", this.form.brandList.name);
      para.append("productCategoryId", this.form.typeList);
      // para.append("productCategoryName", this.form.typeList.name);
      para.append("name", this.form.name);
      // para.append("productSn", this.form.productSn);
      para.append("newStatus", this.form.newStatus);
      para.append("recommandStatus", this.form.recommandStatus);
      para.append("giftGrowth", this.form.giftGrowth);
      para.append("giftPoint", this.form.giftPoint);
      para.append("usePointLimit", this.form.usePointLimit);
      para.append("lowStock", this.form.lowStock);
      para.append("unit", this.form.unit);
      para.append("weight", this.form.weight);
      // para.append("promotionPerLimit", this.form.promotionPerLimit);
      // para.append("promotionType", this.form.promotionType);
      para.append("transfee", this.form.transfee);
      // para.append("promotionStartTime", this.form.activityData[0]);
      // para.append("promotionEndTime", this.form.activityData[1]);
      addProductDto(para).then(data => {
        console.log('第一步修改信息', data);
        //  拿到商品id 然后继续第二步  上传商品图片
        // 转化为代码  就是1，关闭当前窗,2，储存id 3打开下一个窗口
        if (data.code === 10000) {
          this.dialogVisible = false
          this.productId = data.data
          if (this.productIdToAddOrEdit) {
            // this.productPicdialogTwo = true
            //请求获取图片数据
            let para = new URLSearchParams();
            para.append("productId", this.productIdToAddOrEdit)
            quyeryProductPic(para).then(data => {
              console.log(data);
              var list = data.data
              for (let i = 0; i < list.length; i++) {
                if (list[i].typeId == 10) {
                  this.mainPicListTwo.push(list[i])
                } else {
                  this.congPicListTwo.push(list[i])
                }
              }
              console.log(this.mainPicListTwo);
              console.log(this.congPicListTwo);

            })

          } else {
            this.productPicdialog = true
            this.congPicList = []
            this.mainPicList = []
            this.$refs.form.resetFields()
          }

        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
      this.$refs.form.resetFields()

    },
    addUpdataStatuesShop () {
      let para = new URLSearchParams()
      para.append('productId', this.productIdToAddOrEdit)
      para.append('publishStatus', 1)
      para.append('verifyStatus', 1)
      upDateProduct(para).then(data => {
        console.log('数据变化了', data);
        if (data.code === 10000) {
          this.$message({
            message: data.msg,
            type: 'success'
          })
          this.getShopList()
        } else {
          this.$message({
            message: data.msg,
            type: 'error'
          })
        }
      })
      this.$nextTick(() => {
        this.$refs['form'].resetFields()
      })
    },
    //添加商品第二步图片部分
    handlePicSave () {
      //新增
      //将图片传给后台10是主图  20是从图
      const mainData = this.mainPicList

      for (let i = 0; i < mainData.length; i++) {
        let obj = {
          "productId": this.productId,
          "typeId": 10,
          "url": "",
          "isValid": null,
          "idx": i
        }
        obj.url = mainData[i].url
        this.productPics.push(obj)
      }
      const congData = this.congPicList
      for (let i = 0; i < congData.length; i++) {
        let obj = {
          "productId": this.productId,
          "typeId": 20,
          "url": "",
          "isValid": null,
          "idx": i
        }
        obj.url = congData[i].url
        this.productPics.push(obj)
      }
      console.log("看主图是什么：", this.productPics);
      //拿到了所有的图片集合传给后台
      addProductPic(JSON.stringify(this.productPics)).then(data => {
        console.log(data);
        //下一步 关闭当前窗口 然后 打开规格参数窗口
        if (data.code === 10000) {
          // this.$refs.uploadm.clearFiles()
          // this.$refs.uploadc.clearFiles()
          this.mainPicList = []
          this.congPicList = []
          // 1 关闭当前窗口
          this.productPicdialog = false
          // 2 打开下一步的窗口
          this.productAttributedialog = true
        }
      })
      this.$refs.form.resetFields()
    }
  },
  computed: {
    ...mapGetters(['getPromotionTypeList', 'getNewStatusList', 'getRecommandStatusList'])
  },
  mounted () {
    //请求分类列表
    this.getgoodsTypegetByParentId()
    //请求品牌列表
    this.queryBrandList()
    // 获取七牛token
    this.getToken()
    //获取商品列表
    this.getShopList()
  }
}
</script>

<style lang="stylus">
#relen {
  .comond_btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;

    button {
      background-color: #0a3d5f;
      color: #fff;
    }
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
}
</style>
<style>
.avatar-uploader2 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader2 .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon2 {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar2 {
  width: 178px;
  height: 178px;
  display: block;
}
</style>


